import { convert } from 'html-to-text';

export const getTextFromHtmlString = (htmlString: null | string | undefined) =>
  convert(htmlString ?? '');
